import { userStats } from 'app/redux/reducers/ChapterStats/chapterStats.reducer';
import { chaptersStatsStore } from 'app/redux/rootReducer';


export function selectChapterStats(state) {
    return state[chaptersStatsStore][userStats];
}
